
/** Convert a raw base64 string to a Blob */
export function base64ToBlob(base64: string, mime: string): Blob {
    const byteChars = atob(base64);
    const bytes = new Uint8Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) bytes[i] = byteChars.charCodeAt(i);
    return new Blob([bytes], { type: mime });
}

/** Convert a data URL to a Blob */
export function dataUrlToBlob(dataUrl: string): Blob {
    const [header, base64] = dataUrl.split(';base64,');
    if (!base64) {
        throw new Error('Invalid data URL: missing base64 data');
    }
    
    const mime = header.replace('data:', '');
    return base64ToBlob(base64, mime);
}